<template>
	<div>
		<app-overlay-loader v-if="!dataLoaded"/>
		<div v-else class="content-wrapper">
			<div class="row">
				<div class="col-sm-12 col-md-6">
					<app-breadcrumb
						:button="{label: $t('back'), url:urlGenerator(`crm/eve/list`)}"
						:directory="[$t('contacts'), name]"
						:icon="'users'"
						:page-title="name"
					/>
				</div>
				<div class="col-sm-12 col-md-6">
					<div class="float-md-right mb-3 mb-sm-3 mb-md-0">
						<button
							class="btn btn-primary btn-with-shadow"
							data-toggle="modal"
							type="button"
							@click="openDealModal()"
						>{{ $t('add_deal') }}
						</button>
					</div>
				</div>
			</div>

    
			<div class="row">
				<div class="col-xl-4">

					<app-details-information-eve
						class="mb-primary"
						:details-data="formData"
						:details-sync-url="`crm/eves/${formData.id}`"
					@update-request="updateRequest"/>
					
					<tags-eve :eve="formData.id" :tagData="formData.tags" class="mb-primary"/>	
				</div>
				<div class="col-xl-8">
				<component is="app-details-deals-eve"
                     :Deals="formData.deals"
                     :contact-list="eveList"
                     :Id="formData.id"
                     :total-deal="formData.total_deals"
                     component-type="eve"
                     class="mb-primary"
          		/>
					<app-tab v-if="appTapShow" :tabs="todoActivityTab" class="mb-primary" type="horizontal"/>
          <app-common-activity-show-eve
            :Data="formData"
            :edit-url="selectedUrl"
            :activity-filter-url="`crm/eve/activities/`"
            :file-note-url="`crm/eve`"
            component-type="eve"
            v-if="isComponent"
            @open-activity="editActivity"
            @open-note-modal="editNote"
          />
				</div>
			</div>

			<app-deal-modal
				v-if="isDealModalActive"
				:pre-selected-option="{'eve_id':formData.id}"
        component-type="eve"
        :selectedUrlId="formData.id"
				@close-modal="closeDealModal"
			/>


			<app-common-activity-modal

				v-if="eveActivitiesModal"
				:activity="rowData"
				:selected-url="editedUrl"
				@close-modal="closeActivityModal"
			/>

			<app-common-note-modal v-if="isNoteModal" :note="noteRowData" @close-modal="closeNoteModal"/>

		</div>
	</div>
</template>

<script>
import {FormMixin} from "@core/mixins/form/FormMixin.js";
import {formatDateToLocal, onlyTime, onlyTimeFromTime, textTruncate, urlGenerator} from "@app/Helpers/helpers";

export default {
	props: ["selectedUrl"],
	name: "EveDetails",
	mixins: [FormMixin],

	components: {
		"tags-eve": require("./Details/TagsEve").default,
	},
	data() {
		return {
			urlGenerator,
			dataLoaded: false,
			preLoader: false,
			isDealModalActive: false,
			isNoteModal: false,
			eveActivitiesModal: false,
			formData: {},
			appTapShow: false,
			isComponent: true,
			name: "",
			editedUrl: "",
			activitiesList: [],
			isfileNoteFilter: true,

			// Tab Start
			todoActivityTab: [
				{
					name: this.$t("note"),
					icon: "file-text",
					component: "common-note-tab",
					props: "",
					permission: "",
				},
				{
					name: this.$t("file"),
					icon: "paperclip",
					component: "common-file-tab",
					props: "",
					permission: "",
				},

				
				
			],


			rowData: null,
			dealNoteModal: false,
			noteRowData: null,
			value: "",
			formatDateToLocal,
			onlyTimeFromTime,
			onlyTime,
			textTruncate,
		};
	},
	computed: {
		eveList() {
			return this.$store.getters.getEve
		},


		organizationList() {
			return this.$store.getters.getOrganization
		},
	},
	methods: {
		afterSuccessFromGetEditData(response) {
			this.formData = response.data;
			this.name = this.formData.name;
			this.todoActivityTab.forEach((el) => {
				el["props"] = {
					id: this.formData.id,
					eve: "eve",
					contextable_type: "App\\Models\\CRM\\Eve\\Eve",
					
					fileSyncUrl: `crm/eve/file/sync/${this.formData.id}`,
					noteSyncUrl: `crm/eve/note/sync/${this.formData.id}`,
				};
			});

			this.appTapShow = true;
      this.dataLoaded = true;
		},

		updateRequest() {
			this.isComponent = false;
			this.axiosGet(this.selectedUrl).then((response) => {
				this.formData = response.data;
				this.name = this.formData.name;
				this.isComponent = true;
			}).catch((error) => console.log(error));
		},

		updateDealList() {
			this.$hub.$on("deal-update-list", (value = true) => {
				if (value) {
					this.updateRequest();
				}
			});
		},
		updateTagList() {
			this.$hub.$on("tag-list", (value = true) => {
				if (value) {
					this.updateRequest();
				}
			});
		},

		editActivity(activity) {
			this.editedUrl = `crm/activities/${activity.id}`;
			this.rowData = activity;
			this.eveActivitiesModal = true;
		},
		openDealModal() {
			this.isDealModalActive = true;
			setTimeout(function () {
				$("#deal-modal").modal("show");
			});
		},
		closeDealModal() {
			this.isDealModalActive = false;
			$("#deal-modal").modal("hide");
		},
		closeActivityModal() {
			this.eveActivitiesModal = false;
			$("#common-activity-modal").modal("hide");
		},

		editNote(activity) {
			this.isNoteModal = true;
			this.noteRowData = activity;
			setTimeout(() => {
				$("#note-modal").modal("show");
			});
		},
		closeNoteModal() {
			this.isNoteModal = false;
			$("#note-modal").modal("hide");
		},
	},

	mounted() {
		this.updateDealList();
		this.updateTagList();
		this.$store.dispatch("getEve");
		this.$store.dispatch("getPerson");
		this.$store.dispatch('getOrganization');
	},
};
</script>
